import axios from 'axios';
// v1.0.2 - Production Cloudflare Worker

const API_BASE = `https://my-api-js.senthilnayagan100.workers.dev`;

const api = axios.create({
    baseURL: API_BASE,
});

export const createRoom = () => api.post('/room/create/');

export const joinRoom = (pin, deviceId, deviceName, role = "receiver") => 
    api.post('/room/join/', { pin, deviceId, deviceName, role });

export const getRoomStatus = (pin, deviceId) => 
    api.get(`/room/${pin}/status/`, { params: { deviceId } });

export const uploadFile = (formData, onUploadProgress) => 
    api.post('/upload/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress
    });

export const getStreamUrl = (file_id) => `${API_BASE}/stream/${file_id}/`;

export default api;
